var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M0 0L20 0L20 20L0 20L0 0Z",
    id: "path_1"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "mask_1"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path_1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "telefono-movil"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0L20 0L20 20L0 20L0 0Z",
    id: "Background",
    fill: "#FFFFFF",
    fillOpacity: 0,
    fillRule: "evenodd",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#mask_1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(4.3378906 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.87027 0L1.45543 0C0.650098 0 0 0.653014 0 1.45689L0 18.5446C0 19.3477 0.650099 20 1.45543 20L9.87027 20C10.6742 20 11.3257 19.3477 11.3257 18.5446L11.3257 1.45689C11.3257 0.653014 10.6742 0 9.87027 0L9.87027 0ZM3.58646 0.884766L7.74068 0.884766C7.84563 0.884766 7.9309 1.04146 7.9309 1.23532C7.9309 1.42919 7.84563 1.58661 7.74068 1.58661L3.58646 1.58661C3.48079 1.58661 3.39697 1.42919 3.39697 1.23532C3.39697 1.04146 3.48079 0.884766 3.58646 0.884766L3.58646 0.884766ZM5.66361 18.5621C5.15125 18.5621 4.73438 18.1452 4.73438 17.6321C4.73438 17.119 5.15126 16.7036 5.66361 16.7036C6.1745 16.7036 6.59138 17.119 6.59138 17.6321C6.59138 18.1452 6.1745 18.5621 5.66361 18.5621L5.66361 18.5621ZM10.2354 15.3779L1.09106 15.3779L1.09106 2.45825L10.2354 2.45825L10.2354 15.3779L10.2354 15.3779Z",
    id: "Shape",
    fill: "#10B48C",
    fillRule: "evenodd",
    stroke: "none"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.10686d3f35053a92de9167f074b97be6.svg";
export { ForwardRef as ReactComponent };